export default __webpack_public_path__ + "static/banner-media-release-sep3-2b9e2f51bcd2625219548f4b249775c7.jpg";